import React from "react";
import { ChevronUp, ChevronDown } from "lucide-react";

const AdminInput = ({
  label = "Input",
  name,
  value,
  onChange,
  placeholder = "",
  type = "text",
  min,
  max,
  step,
  helperText = "",
  required = false,
  className = "",
  inputClassName = "",
  disabled = false,
  readOnly = false,
  error = "",
}) => {
  // Handle increment for number inputs
  const handleIncrement = () => {
    if (type === "number" && !disabled && !readOnly) {
      const currentValue = parseFloat(value) || 0;
      const newValue =
        max !== undefined ? Math.min(currentValue + 1, max) : currentValue + 1;
      const event = {
        target: {
          name,
          value: newValue.toString(),
        },
      };
      onChange(event);
    }
  };

  // Handle decrement for number inputs
  const handleDecrement = () => {
    if (type === "number" && !disabled && !readOnly) {
      const currentValue = parseFloat(value) || 0;
      const minValue = min !== undefined ? parseFloat(min) : -Infinity;
      const newValue = Math.max(currentValue - 1, minValue);
      const event = {
        target: {
          name,
          value: newValue.toString(),
        },
      };
      onChange(event);
    }
  };

  return (
    <div className={`mb-4 ${className}`}>
      {label && (
        <label
          htmlFor={name}
          className="mb-[10px] block font-medium text-primary-400 text-sm"
        >
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <div className="relative">
        <input
          id={name}
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder || label}
          required={required}
          min={min}
          max={max}
          step={step}
          disabled={disabled}
          readOnly={readOnly}
          className={`w-full border p-3 text-sm rounded-lg active:outline-none focus:outline-none ${error ? "border-red-500" : "border-[#e1e3ea]"
            } ${disabled || readOnly ? "bg-gray-100 cursor-not-allowed" : ""
            } ${type === "number" ? "pr-10" : ""
            } ${inputClassName} placeholder:text-sm`}
        />

        {/* Up/Down arrows for number inputs */}
        {type === "number" && !disabled && !readOnly && (
          <div className="absolute right-2 top-1/2 -translate-y-1/2 flex flex-col">
            <button
              type="button"
              onClick={handleIncrement}
              className="p-0.5 hover:bg-gray-100 rounded transition-colors"
            >
              <ChevronUp className="w-4 h-4 text-gray-600" />
            </button>
            <button
              type="button"
              onClick={handleDecrement}
              className="p-0.5 hover:bg-gray-100 rounded transition-colors"
            >
              <ChevronDown className="w-4 h-4 text-gray-600" />
            </button>
          </div>
        )}
      </div>

      {error && (
        <p className="text-xs text-red-500 font-medium my-1">{error}</p>
      )}

      {helperText && !error && (
        <p className="text-xs text-[#a1a5b7] font-normal my-1 ">{helperText}</p>
      )}
    </div>
  );
};

export default AdminInput;
